import { useNavigation } from "@react-navigation/native";
import React, { useEffect, useState, useCallback } from "react";
import {
  ActivityIndicator,
  FlatList,
  Modal,
  StyleSheet,
  TouchableNativeFeedback,
  TouchableWithoutFeedback,
  View,
  Image,
} from "react-native";
import { useDispatch, useSelector } from "react-redux";
import CrossIcon from "@assets/svg/CrossIcon";
import SuccessSmall from "@assets/svg/SuccessSmall";
import Text from "@components/AppText";
import useCartActions from "@components/CMS/useCartActions";
import { normalize, width } from "@constants/metrics";
import testIds from "@constants/testIds";
import useLeaderState from "@hooks/useLeaderState";
import { actions as productActions } from "@reducers/productReducer";
import { actions } from "@reducers/qtySelectReducer";
import analytics from "@services/analytics";
import { notifyForOOS } from "@services/api";
import parseTemplate from "@utils/parseTemplate";
import { shareOnWhatsapp } from "@utils/shareEntity";
import {
  ORDER_FLOW_EVENTS,
  SHARING_EVENTS,
} from "../../constants/analyticsEventsCT";
import AddnMinBtn from "./AddnMinBtn";
import DiscountStrip from "./DiscountStrip";
import KhareedBtn from "./KhareedBtn";
import NotifyButton from "./NotifyButton";
import ShareOnWA from "./ShareOnWA";

const QtySelectBottomView = () => {
  const {
    visible = false,
    items = [],
    identifier,
  } = useSelector((state) => state.qtySelection);

  const dispatch = useDispatch();

  const [viewH, setViewH] = useState(0);

  const calcDimension = (e) => {
    const {
      nativeEvent: {
        layout: { height },
      },
    } = e;
    if (height > viewH) {
      setViewH(height);
    }
  };

  const closingModalHandler = () => {
    setViewH(0);
    dispatch(actions.hideBottomSheet());
  };

  const containerHeightHandler = () => {
    if (items.length > 5) {
      return 86.91 * 5.5;
    } else {
      return 86.91 * items.length;
    }
  };

  const _keyExtractor = useCallback(
    (item, index) => `key-${item.empty ? index : item.sku_id}`,
    [],
  );

  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="slide"
      onRequestClose={closingModalHandler}
    >
      <View
        testID={testIds.Select_Quanity_Main_View}
        style={{ flex: 1, backgroundColor: "rgba(0, 0, 0, 0.4)" }}
      >
        <TouchableWithoutFeedback onPress={closingModalHandler}>
          <View style={{ flex: 1 }} />
        </TouchableWithoutFeedback>
        <View style={styles.container}>
          <View style={styles.topSection}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: normalize(5),
              }}
            >
              <Text bold style={{ fontSize: normalize(16) }}>
                सेलेक्ट करें
              </Text>
              <TouchableNativeFeedback onPress={closingModalHandler}>
                <View style={{ padding: 5, paddingTop: 0 }}>
                  <CrossIcon />
                </View>
              </TouchableNativeFeedback>
            </View>
            <Text
              style={{
                fontSize: normalize(14),
                color: "rgba(0, 0, 0, 0.56)",
              }}
            >
              {identifier}
            </Text>
          </View>
          {items.length == 1 ? (
            <ActivityIndicator color={"red"} />
          ) : (
            <View
              style={{
                borderTopWidth: 1,
                borderTopColor: "rgba(0,0,0,0.1)",
                height: containerHeightHandler(),
              }}
            >
              <FlatList
                data={[...items, { empty: true }]}
                keyExtractor={_keyExtractor}
                renderItem={({ item }) => {
                  if (item.empty) {
                    return null;
                  } else {
                    return (
                      <ProductView
                        {...item}
                        closeBottomSheet={() =>
                          dispatch(actions.hideBottomSheet())
                        }
                        updatePDU={() => {
                          console.log(
                            "update of pdu happening for id",
                            item.sku_id,
                          );
                          dispatch(actions.setDisplayId(item.sku_id));
                        }}
                        dispatch={dispatch}
                        onLayoutHandler={calcDimension}
                      />
                    );
                  }
                }}
                ItemSeparatorComponent={() => (
                  <View
                    style={{
                      height: 1,
                      backgroundColor: "rgba(0,0,0,0.1)",
                    }}
                  />
                )}
              />
            </View>
          )}
        </View>
      </View>
    </Modal>
  );
};

export default QtySelectBottomView;

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    bottom: 0,
    right: 0,
    left: 0,
    backgroundColor: "white",
    borderTopLeftRadius: normalize(20),
    borderTopRightRadius: normalize(20),
    borderWidth: 0,
    // paddingBottom: normalize(10),
    // maxHeight: height * 0.8,
  },
  topSection: {
    paddingHorizontal: normalize(15),
    paddingTop: normalize(15),
    paddingBottom: normalize(10),
  },
  mrp: {
    lineHeight: normalize(16),
    color: "rgba(0, 0, 0, 0.86)",
  },
  price_per_unit: {
    color: "rgba(0, 0, 0, 0.56)",
  },
  offertext: {
    color: "rgba(0, 0, 0, 0.56)",
    fontSize: normalize(13),
    marginLeft: normalize(6),
  },
});

const formatPrice = (price) => {
  return price.split(".") || "";
};

const ProductView = (props) => {
  const {
    discount,
    discount_type,
    short_name_hi,
    product_image,
    price_tl_single_buy,
    price_per_unit,
    discount_price,
    mrp,
    grammage,
    custom_text,
    custom_symbol,
    product_status,
    variant_identifier,
    slug,
    sku_id,
    product_name_hi,
    closeBottomSheet = () => {},
    updatePDU = () => {},
    bottom = {},
    onLayoutHandler = () => {},
    dispatch = () => {},
    sharingLink,
    sharingTemplate,
  } = props;

  const user = useSelector((state) => state.auth.user);

  const dataObj = {
    mrp,
    price_tl_single_buy,
    product_name_hi,
    discount_price,
    leaderName: props.leaderName,
    leaderId: user.user_id,
    slug,
  };

  const { addCart, removeCart, countOfItem, isCartValueLoading } =
    useCartActions();

  const { selectedContact, cart } = useSelector((state) => ({
    selectedContact: state.customer.selectedContact,
  }));
  const { canLeaderUseApp } = useLeaderState();

  const [showCartActions, setShowCartActions] = useState(false);
  const [notified, setNotified] = useState(false);

  const navigation = useNavigation();

  const notifyOOS = () => {
    setNotified(true);
    notifyForOOS({ sku_id })
      .then(() => {
        dispatch(productActions.requestForOosSkus());
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const oosProducts = useSelector((state) => state.products.oosProducts) || [];

  const isOutOfStockNotified =
    oosProducts.findIndex((p) => p.sku_id === sku_id) !== -1;

  useEffect(() => {
    setNotified(isOutOfStockNotified);
  }, [isOutOfStockNotified, oosProducts]);

  const addToCart = () => {
    if (!canLeaderUseApp()) {
      return;
    }
    const eventPayload = {
      sku_id,
      price: price_tl_single_buy,
      product_name: short_name_hi,
      bundle: true,
    };
    updatePDU();
    addCart(sku_id, selectedContact.user_id, () => {}, undefined, eventPayload);
    setTimeout(closeBottomSheet, 500);
    // closeBottomSheet();
  };

  const removeFromCart = () => {
    if (!canLeaderUseApp()) {
      return;
    }
    analytics.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_REMOVED, {
      sku_id,
      price: price_tl_single_buy,
      product_name: short_name_hi,
      bundle: true,
    });
    updatePDU();
    removeCart(sku_id, selectedContact.user_id);
    setTimeout(closeBottomSheet, 500);
  };

  const shareProductOnWhatsApp = () => {
    analytics.trackEvent(SHARING_EVENTS.PRODUCT_SHARE, {
      sku_id,
      price_tl_single_buy,
      product_name: product_name_hi,
    });

    const { app_share_app_link } = user;

    let percentage =
      ((parseInt(mrp) - parseInt(price_tl_single_buy)) / parseInt(mrp)) * 100;

    if (percentage === 0) {
      percentage = "";
    } else {
      percentage = percentage.toFixed(0);
    }

    const link = `${app_share_app_link}?app_screen=ProductDetails&slug=${slug}&channel=cl_product_share`;

    const message = `
    ${product_name_hi}\nCityMall Price - ${price_tl_single_buy} ~MRP~ - ~${mrp}~ ${
      percentage == 0 ? "" : `(${percentage}%) Off`
    }\n\nआर्डर करे: ${link}
    `;
    shareOnWhatsapp({ message, image: product_image });
  };

  return (
    <View
      onLayout={onLayoutHandler}
      style={[
        {
          width: "100%",
          paddingVertical: normalize(10),
          paddingHorizontal: normalize(15),
          flex: 1,
        },
      ]}
    >
      <DiscountStrip discount={discount} discount_type={discount_type} />
      <View style={{ flexDirection: "row" }}>
        <Image
          resizeMode={"contain"}
          style={{
            width: normalize(60),
            height: normalize(60),
            opacity: product_status == "Active" ? 1 : 0.4,
          }}
          source={
            product_image
              ? {
                  uri: product_image,
                }
              : require("@assets/images/defaultImage.webp")
          }
        />
        <View style={{ paddingHorizontal: normalize(8) }}>
          <Text
            style={{ color: "rgba(0, 0, 0, 0.86)", fontSize: normalize(14) }}
          >
            {grammage}
          </Text>
          {product_status == "Active" ? (
            <View style={{ flexDirection: "row", flex: 1 }}>
              <Text bold style={{ fontSize: normalize(16) }}>
                ₹{formatPrice(price_tl_single_buy)[0]}
                {formatPrice(price_tl_single_buy)[1] && (
                  <Text bold style={{ fontSize: normalize(12) }}>
                    .{formatPrice(price_tl_single_buy)[1]}
                  </Text>
                )}
              </Text>
              <Text
                style={{
                  ...styles.mrp,
                  marginLeft: normalize(10),
                  fontSize: normalize(12),
                  marginTop: normalize(5),
                  textDecorationLine:
                    parseFloat(mrp) !== parseFloat(price_tl_single_buy)
                      ? "line-through"
                      : "none",
                }}
              >
                ₹{mrp}
              </Text>
            </View>
          ) : (
            <></>
          )}
          {price_per_unit && product_status == "Active" ? (
            <View>
              <Text
                numberOfLines={2}
                style={[styles.price_per_unit, { fontSize: normalize(12) }]}
              >
                ({price_per_unit})
              </Text>
            </View>
          ) : (
            <></>
          )}
        </View>
        <View
          style={{
            flex: 1,
            alignItems: "center",
            //   paddingTop: normalize(15),
            //   backgroundColor: "blue",
          }}
        >
          <View style={{ marginLeft: "auto" }}>
            {product_status === "Active" ? (
              <>
                <View
                  style={{
                    flex: 1,
                    justifyContent: "center",
                  }}
                >
                  <ShareOnWA
                    width={normalize(40)}
                    paddingBottom={0}
                    onPress={() => {
                      if (!canLeaderUseApp()) {
                        return;
                      }
                      shareProductOnWhatsApp();
                    }}
                    showCTA={false}
                  />
                </View>
              </>
            ) : (
              <View style={{ justifyContent: "space-between" }}>
                <Text
                  style={{
                    color: "#FF2E00",
                    fontSize: normalize(14),
                    textAlign: "right",
                    marginBottom: normalize(4),
                  }}
                >
                  यह प्रोडक्ट स्टॉक में नहीं है
                </Text>
                {!notified ? (
                  <NotifyButton width={width * 0.4} onPress={notifyOOS} />
                ) : (
                  <View
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.05)",
                      borderRadius: 6,
                      paddingHorizontal: 5,
                      flexDirection: "row",
                      alignItems: "center",

                      alignSelf: "center",
                      height: normalize(30),
                    }}
                  >
                    <SuccessSmall />
                    <Text
                      style={{
                        color: "rgba(0, 0, 0, 0.56)",
                        fontSize: normalize(14),
                        marginLeft: normalize(2),
                      }}
                    >
                      आपको सूचित किया जायेगा
                    </Text>
                  </View>
                )}
              </View>
            )}
          </View>
        </View>
      </View>
      {custom_symbol && custom_text ? (
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginTop: normalize(7),
            paddingRight: normalize(25),
          }}
        >
          <Image
            resizeMode="contain"
            source={{
              uri: custom_symbol,
            }}
            style={{ height: normalize(25), width: normalize(25) }}
          />
          <Text
            bold
            style={styles.offertext}
            numberOfLines={1}
            ellipsizeMode="tail"
          >
            {custom_text}
          </Text>
        </View>
      ) : (
        <></>
      )}
    </View>
  );
};
